import DeliveryCardFunctional from './Components/delivery-card-functional';
import React from 'react';
import reducer from './reducer';
import sagas from './sagas';
import { withReducer } from '@store/reducerLoader';

const DeliveryCardPage = ({ allowNavigate, buttonMode, buttonName, navigateDisabled, companyInfoDetails }) => {
	return (
		<DeliveryCardFunctional
			allowNavigate={allowNavigate}
			buttonMode={buttonMode}
			buttonName={buttonName}
			navigateDisabled={navigateDisabled}
			companyInfoDetails={companyInfoDetails}
		/>
	);
};

const ReducedScreen = withReducer('deliveryinfo', reducer, sagas)(DeliveryCardPage);
export default ReducedScreen;
